import '../filter-palette/filter-palette';
import '../search-palette/search-palette';
import '../subscription-palette/subscription-palette';
import '../sspb-probono-opportunity-card/src/components/opportunity-card/opportunity-card';

import '../../utils/SearchQuery'

import axios from 'axios';
import { Component, Element, h, Listen, Prop, State } from '@stencil/core';
import { SearchQuery } from '../../utils/SearchQuery';

@Component({
  tag: 'probono-catalog',
  styleUrl: 'probono-catalog.css',
  shadow: true
})
export class ProbonoCatalog {
    @Prop({ attribute: 'cohort-id' }) cohortId: number = 0;
    @Prop({ attribute: 'partner-id' }) partnerId: number = null;
    @Prop({ attribute: 'partner-site-name' }) partnerSiteName: string = '';
    @Prop({ attribute: 'default-query' }) defaultQuery: string = ''; 
    @Prop({ attribute: 'cards-per-page' }) cardsPerPage: number = 8;

    @Element() el: HTMLElement;

    @State() searchQueryString = '';
    @State() queryAreas: Array<string>;
    @State() queryTypes: Array<string>;
    @State() queryRegions: Array<string>;
    @State() queryPartners: Array<string>;
    @State() queryString: string;
    @State() cohortContactURL: string = '';
    @State() cohortName: string = '';
    @State() cohortFeedbackURL: string = '';
    @State() cohortBannerHTML: string = '';
    @State() cohortPartners: Array<any> = [];
    @State() searchQuery: SearchQuery;
    @State() baseURL: string;
    @State() firstLoadComplete: boolean = false;
    @State() noOpportunitiesAvailable: boolean;
    @State() volunteerName: string = '';
    @State() volunteerEmail: string = '';
    @State() volunteerPhone: string = '';
    @State() volunteerBarNo: string = '';

    private fullOpportunityList: Array<any> = [];
    @State() pageOpportunityList: Array<any> = [];
    @State() pageIndex: number = 1;
    private opportunitiesPerPage: number;
    @State() totalNumOfPages: number = 1;

    componentWillLoad() {
        // Configure the base URL for meta, opportunities, and other requests.
        this.baseURL = `https://api.probono.savvysuit.com/v2/cohort/${this.cohortId}`

        if((this.partnerSiteName != null) && (this.partnerSiteName != '')) {
            this.queryPartners = [this.partnerSiteName];
        }

        this.searchQuery = new SearchQuery(this.cohortId, '');
        this.searchQuery.PrepareSearchQuery(this.defaultQuery);
        this.searchQuery.replacePartners([this.partnerSiteName])
        this.searchQueryString = this.searchQuery.generateSearchQuery();

        try {
            if((!isNaN(this.cardsPerPage) && (this.cardsPerPage > 0) && (this.cardsPerPage <= 250))) {
                this.opportunitiesPerPage = this.cardsPerPage;
                console.debug('Successfully set the number of cards per page.')
            } else {
                this.opportunitiesPerPage = 8;
                console.debug('Using the default number of cards per page.')
            }
        } catch(e) {
            this.opportunitiesPerPage = 8;
            console.error('Failure determining the number of cards per page.', e.toString())
        }
        
        this.loadCatalogMeta();
    }

    @Listen('areaSelectionCompleted')
    updatedAreaTypeSelection(event: CustomEvent) {
        console.log('Received the custom areaTypeSelected event: ', event.detail);

        if(this.firstLoadComplete) {
            this.searchQuery.replaceAreas(event.detail);
            this.searchQueryString = this.searchQuery.generateSearchQuery();
        }
        
        this.updateSearchQuery({ detail: this.searchQueryString })
    }

    @Listen('typeSelectionCompleted')
    updatedOpportunityTypeSelection(event: CustomEvent) {
        console.log('Received the custom typeSelectionCompleted event: ', event.detail);

        if (this.firstLoadComplete) {
            this.searchQuery.replaceTypes(event.detail);
            this.searchQueryString = this.searchQuery.generateSearchQuery();
        }
        
        this.updateSearchQuery({ detail: this.searchQueryString })
    }

    @Listen('partnersSelectionCompleted')
    updatedPartnersSelection(event: CustomEvent) {
        console.log('Received the custom partnersSelectionCompleted event: ', event.detail);

        if(this.firstLoadComplete) {
            this.searchQuery.replacePartners(event.detail);
            this.searchQueryString = this.searchQuery.generateSearchQuery();
        }

        this.updateSearchQuery({ detail: this.searchQueryString })
    }

    @Listen('regionSelectionCompleted')
    updatedRegionSelection(event: CustomEvent) {
        console.log('Received the custom regionSelectionCompleted event: ', event.detail);

        if(this.firstLoadComplete) {
            this.searchQuery.replaceLocations(event.detail);
            this.searchQueryString = this.searchQuery.generateSearchQuery();
        }

        this.updateSearchQuery({ detail: this.searchQueryString })
    }

    @Listen('toggleSubscriptionPalette')
    updateSubscriptionPaletteVisibility() {
        if(this.el.shadowRoot.querySelector('subscription-palette').classList.contains("HiddenPalette")) {
            this.el.shadowRoot.querySelector('subscription-palette').classList.remove("HiddenPalette")

            // console.log("Displaying the subscription bar.")
        } else {
            this.el.shadowRoot.querySelector('subscription-palette').classList.add("HiddenPalette")

            // console.log("Hiding the subscription bar.")
        }
    }

    @Listen('toggleFilterPalette')
    updateFilterPaletteVisibility() {
        if(this.el.shadowRoot.querySelector('filter-palette').classList.contains("HiddenPalette")) {
            this.el.shadowRoot.querySelector('filter-palette').classList.remove("HiddenPalette")

            // console.log("Displaying the search filter bar.")
        } else {
            this.el.shadowRoot.querySelector('filter-palette').classList.add("HiddenPalette")

            // console.log("Hiding the search filter bar.")
        }
    }

    @Listen('updatedSearchQuery')
    updateSearchQuery(newSearchQueryStringEvent: any) {
        console.log(`Received the custom updatedSearchQuery event [${this.firstLoadComplete}]`);

        if(this.firstLoadComplete) {
            this.searchQuery.PrepareSearchQuery(newSearchQueryStringEvent.detail)

            this.queryTypes = this.searchQuery.queryTypes
            this.queryAreas = this.searchQuery.queryAreas
            this.queryPartners = this.searchQuery.queryPartners
            this.queryRegions = this.searchQuery.queryCountyLocations

            this.searchQueryString = newSearchQueryStringEvent.detail
        }

        console.log('Updated search string available.')
        //this.render();

        const that: any = this

        console.log('Requesting opportunity list.');

        const payload = {
            query: this.searchQueryString
        }

        axios.post(this.baseURL.concat('/search'), payload)
            .then((response) => {
                console.log('Received current opportunity data.');

                that.fullOpportunityList = response.data;
                that.pageIndex = 1;

                console.log(`Opportunities updated, found ${this.fullOpportunityList.length} opportunities(s)`)

                that.updateOpportunities();
            })
            .catch(() => {
                console.error('FAILURE: Unable to retrieve an updated opportunity list.');

                that.fullOpportunityList = [];

                that.updateOpportunities();
            })
    }

    @Listen('volunteerInformationUpdated')
    updateVolunteerInformation(newVolunteerInformation: any) {
        console.log('Volunteer Information Updated.');

        this.volunteerName = newVolunteerInformation.detail.volunteerName;
        this.volunteerEmail = newVolunteerInformation.detail.volunteerEmail;
        this.volunteerPhone = newVolunteerInformation.detail.volunteerPhoneNumber;
        this.volunteerBarNo = newVolunteerInformation.detail.volunteerBarNumber;
    }

    updateOpportunities () {
        console.log('Updating opportunities being displayed.')
        this.firstLoadComplete = true;

        this.pageOpportunityList = this.computeOpportunityList(this.pageIndex, this.fullOpportunityList)
        this.totalNumOfPages = this.computeTotalPages(this.fullOpportunityList)
    
        if (this.fullOpportunityList.length === 0) {
          this.noOpportunitiesAvailable = true
        } else {
          this.noOpportunitiesAvailable = false
        }

        //this.render()
    }
    
    computeTotalPages(fullOpportunityList) {
        try {
            // Calculate the smallest integer greater than or equal to the
            // number of cases divided by cards per page displayed.
            var iPages = Math.ceil(fullOpportunityList.length / this.opportunitiesPerPage)

            // If the number of pages is "0",
            if (iPages === 0) {
                // Return 1, there's at least the page we're looking at.
                return 1
            } else {
                // Otherwise, return the number of pages.
                return iPages
            }
        } catch (e) {
            // Do nothing for now.
        }
    }

    computeOpportunityList(pageIndex, fullOpportunityList) {
        // Convert the page index to a number.
        var page = parseInt(pageIndex)
        // "0" base the index and protect for neg. index value.
        if (page > 0) {
            page = page - 1
        }

        // Slide the case list for the proper page.
        try {
            return fullOpportunityList.slice((page * this.opportunitiesPerPage), (page * this.opportunitiesPerPage) + this.opportunitiesPerPage)
        } catch (e) {
            // Do nothing for now.
            // console.debug(this.ajaxResponse)
            // console.error(e)
            return []
        }
    }

    nextPage() {
        if (Math.ceil(this.fullOpportunityList.length / this.opportunitiesPerPage) > this.pageIndex) {
            this.pageIndex = this.pageIndex + 1
        }

        this.updateOpportunities()
    }

    previousPage() {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1
        }

        this.updateOpportunities()
    }

    loadCatalogMeta () {
        const that = this

        axios.get(this.baseURL.concat('/catalog'))
            .then(function (response) {
                console.log('Received catalog meta')

                const responseData: any = response.data;

                that.cohortName = responseData.name
                that.cohortContactURL = responseData.contact_url
                that.cohortFeedbackURL = responseData.feedback_url
                that.cohortBannerHTML = responseData.banner_html
                that.cohortPartners = responseData.partners;

                if ((that.partnerId >= 0) && (that.partnerId != null)) {
                    for (const partnerRec of responseData.partners) {
                        if(partnerRec.partner_id === that.partnerId) {
                            that.searchQuery.replacePartners([partnerRec.legalserver_site_name]);
                            that.queryPartners = [partnerRec.legalserver_site_name];
                            that.searchQueryString = that.searchQuery.generateSearchQuery();

                            break;
                        }
                    }

                    that.updateSearchQuery({ detail: that.searchQueryString })
                } else {
                    that.updateSearchQuery({ detail: '' })
                }
            })
            .catch(function (e) {
                console.error(e)
                console.log('I was unable to update the case list')
            });
    }

    render() {
        const partnersNarrative = (this.cohortContactURL !== '' && this.cohortName !== '') ? (<p>Built with <a href={this.cohortContactURL}>{this.cohortName}</a>. Data by <a href="https://www.legalserver.org/">LegalServer</a> & <a href="https://www.savvysuit.com">SavvySuit</a>.</p>) : null;
        const feedbackNaartive = (this.cohortFeedbackURL !== '') ? (<p>If you have questions or suggestions, <a href={this.cohortFeedbackURL}>let us know</a>.</p>) : null;
        const headerHTML = (this.cohortBannerHTML !== '' && this.cohortBannerHTML !== null) ? <div id="BannerStage" innerHTML={this.cohortBannerHTML}></div> : null;
        const loadingHTML = (!this.firstLoadComplete) ? <div class="OpportunityEmptyNotice">One moment, loading cases....</div> : null;
        const noOpportunitiesHTML = (this.noOpportunitiesAvailable) ? <div class="OpportunityEmptyNotice">I'm sorry but there are no cases available, try a different search term.</div> : null;
        const currentYear = new Date().getFullYear();

        return (
            <div id="SSPBCatalogStage">
                {headerHTML}
                <search-palette cohort-id={this.cohortId} search-query={this.searchQueryString} />
                <subscription-palette cohort-id={this.cohortId} search-query={this.searchQueryString} class="HiddenPalette" />
                <filter-palette cohort-id={this.cohortId} class="HiddenPalette" typeSelections={this.queryTypes}
                    areaSelections={this.queryAreas} partnerSelections={this.queryPartners} regionSelections={this.queryRegions} />
                <div id="SSPBCardList">
                    {loadingHTML}
                    {noOpportunitiesHTML}
                    {this.pageOpportunityList.map((oppoRec) => <opportunity-card 
                        key={oppoRec.opportunity_id}
                        cohort-id={oppoRec.partner.cohort_id}
                        opportunity-type={oppoRec.type}
                        opportunity-id={oppoRec.opportunity_id}
                        opportunity-title={oppoRec.pb_opportunity_note}
                        opportunity-summary={oppoRec.pb_opportunity_summary}
                        loc-county={oppoRec.pb_opportunity_county}
                        loc-state={oppoRec.partner.state_abbr}
                        opportunity-category={oppoRec.legal_problem_code_descr}
                        partner-opportunity-id={oppoRec.identification_number}
                        partner-name={oppoRec.partner.partner_name}
                        partner-id={oppoRec.partner_id}
                        clinic-sessions={JSON.stringify(oppoRec.clinic_sessions)}
                        volunteer-name={this.volunteerName}
                        volunteer-email={this.volunteerEmail}
                        volunteer-phone={this.volunteerPhone}
                        volunteer-bar-no={this.volunteerBarNo}
                    />)}
                    <div class="ClearBoth">&nbsp;</div>
                </div>
                <div id="PaginationPalette">
                    <ion-grid>
                        <ion-row>
                            <ion-col><ion-button fill="clear" onClick={this.previousPage.bind(this)}>&laquo; Go Back</ion-button></ion-col>
                            <ion-col><div class="PaginationStatus">Page {this.pageIndex} of {this.totalNumOfPages}</div></ion-col>
                            <ion-col><ion-button fill="clear" onClick={this.nextPage.bind(this)}>See More &raquo;</ion-button></ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
                <div id="SSPBFooter">
                    <p>&copy; SavvySuit 2015-{currentYear}. All rights reserved.</p>
                    {partnersNarrative}
                    {feedbackNaartive}
                    <p>Version 5.11 -- <a href="https://www.savvysuit.com/pro-bono-matters-terms-of-use">Our Terms of Use</a></p>
                </div>
            </div>
        );
    }
}
